import { useMutation } from '@tanstack/react-query';
import { backendServices } from '../../services';
import { ValidateTinRequestViewModel } from '../../services/backendServices/ViewModels';

/** POST /DocumentType/ValidateTIN — verify a TIN via Sovos. */
export function useValidateTin(params: {
    SupplierCompanyId: number | null;
    VendorId: number | null;
    BuyerCompanyId: number | null;
}) {
    const mutation = useMutation({
        mutationFn: async (body: ValidateTinRequestViewModel) => {
            const api = new backendServices.Apis.DocumentTypeApi();
            const res = await api.validateTin({
                ...body,
                VendorId: params.VendorId ?? undefined,
                SupplierCompanyId: params.SupplierCompanyId ?? undefined,
                BuyerCompanyId: params.BuyerCompanyId ?? undefined,
            });
            return res.data;
        },
    });

    return mutation;
}
